import React from "react"
import { Container, Grid, Button } from "semantic-ui-react"
import { Link } from "react-router-dom"
import "./Overview.css"

export class OverviewDirectPersonal extends React.Component {
  render = () => {
    const { nextUrl } = this.props
    return (
      <Container textAlign="center" className="white">
        <Grid centered stackable className="overview_maindiv">
          <Grid.Row style={{ paddingBottom: "0px" }}>
            <Grid.Column textAlign="center">
              <h2 className="overview__Heading">Woo hoo!</h2>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{ paddingTop: "0px" }}>
            <Grid.Column
              className="overview__Description"
              width={14}
              textAlign="center"
            >
              <p className="overview__DescriptionText">
                You’re <i>almost</i> a financial action hero! Just a few more
                steps and you’ll be ready to fly with SAVVI.
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row centered columns={1}>
            <Grid.Column width={10}>
              <div className="overview_title">
                You’ve chosen our personal plan!
              </div>
              <p>
                Welcome to the most comprehensive, high-touch version of SAVVI.
                How’d you get so smart? You’ll receive quality financial advice
                and all of the awesome capabilities of the tool: organizing your
                accounts, setting goals and getting actionable advice. But
                beyond the super sweet digital experience, you’ll also have a
                personal coach (yes an actual person!) to help you through the
                entirety of your SAVVI journey.
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row centered columns={1}>
            <Grid.Column width={10}>
              <div className="overview_title">
                So this coach I’m getting, what do they do?
              </div>
              <p>
                The coach you work with will help guide you through SAVVI. SAVVI
                provides the advice; your coach helps you get it as quickly as
                possible. You and your coach will have an initial call to go
                over how the SAVVI platform works and to direct you on an
                efficient way to get started. They’ll be available to help
                establish your account, so you can get organized and on your way
                to an action plan ASAP. Then they’ll check in quarterly to make
                sure you’re on track with your plan and goals. And if you need
                more help? They'll be available for up to 30 minutes of
                additional phone consultation every quarter. Think of your SAVVI
                coach as a personal trainer for your money… you’ll feel great
                without the sweat and sore muscles that come from actual
                exercise.
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row centered columns={1}>
            <Grid.Column width={10}>
              <div className="overview_title">A few more things to know</div>
              <ul className="overview__List">
                <li>
                  The advice you’re going to get… it’s personalized and
                  independent. We put your best interests first. Great, right?
                </li>
                <li>
                  We protect your data with layers of security. SAVVI cares
                  about data privacy and security and has a SOC 2 Type II
                  Certification to prove it.
                </li>
                <li>
                  The agreements you’re about to see acknowledge our promises to
                  you. It’s stronger than a pinky swear and written by lawyers.
                </li>
              </ul>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <div className="overview_details">
                <p>
                  Ready?
                  <br />
                  Review. Accept.
                  <br />
                  And Away We Go!
                </p>
                <br />
                <Link to={nextUrl} className="navlink">
                  <Button
                    primary
                    size="big"
                    className="overview_Button"
                    data-testid="continue"
                  >
                    Continue
                  </Button>
                </Link>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    )
  }
}
